import React, { useEffect, useState } from "react";
// import {
//   getANCWeek,
//   getHistoryVisitData,
//   getOncologyPreviousVisitsData,
// } from "../../services/oncologyEmr/OncologyEmrServices";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { Box, Modal } from "@mui/material";
// import PatientInfo from "../emr/oncologyEMR/PatientInfo";

export default function ANCView(props) {
  const [data, setData] = useState(null);
  const [vistitList, setVisitList] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => {
    if (selectedRow !== null) {
      let obj = {
        department: props.patientData?.department,
        patientInfoId: props.patientData?.patientId,
        visitIdList: [selectedRow?.visitId],
        visitNumber: [selectedRow?.visitNumber],
        doctorId: selectedRow?.doctorId,
      };
      // getHistoryVisitData(obj).then((response) => {
      //   if (response.data?.statusCode === 200) {
      //     setData(response.data.result);
      //     //    setAnc(response.data.map);
      //   } else {
      //     console.log("response is not found");
      //   }
      // });
    }
  }, [selectedRow]);

  let vitalsFill;
  let pastHistoryFill;
  let examinations;
  let obstetricHistory;
  useEffect(() => {
    if (data?.length > 0) {
      examinations = Object.values(props.data?.examinations);
      obstetricHistory = Object.values(props.data?.obstetricHistory);
      vitalsFill = Object.values(data?.vitals);
      pastHistoryFill = Object.values(data.pastHistory);
    }
  }, [data]);
  const areAllVitalsNull =
    data?.vitals &&
    typeof data?.vitals === "object" &&
    Object.values(data?.vitals).every((value) => value === null);

  useEffect(() => {
    if (props.openANcView === true) {
      // getANCWeek(
      //   props.patientData?.patientId,
      //   props.patientData?.department
      // ).then((response) => {
      //   if (response.data.result.pastVisits) {
      //     let result = JSON.parse(response.data.result.pastVisits);
      //     setVisitList(result);
      //   }
      // });
    }
  }, [props.patientData, props.openANcView]);
  console.log("data7895", data);
  const handleSelect = (week) => {
    setSelectedWeek((prevSelectedWeek) =>
      prevSelectedWeek === week ? null : week
    );
  };

  return (
    <Modal
      open={props.openANcView}
      // onClose={confirmationHandleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          border: "2px solid #848211",

          boxShadow: 24,
          px: 2,
          // pb: 4,
          width: "95%",
          height: "95%",
          overflowY: "auto",

          "&::-webkit-scrollbar": {
            width: "5px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#C8DDFD",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#0B83A5",
            borderRadius: "6px",
          },
        }}
        className="w-[95%] lg:w-[99%]"
      >
        <div className="flex py-2 gap-2">
          <label className="  font-bold  text-center">ANC Planner</label>
          <div className="justify-end">
            <CancelPresentationIconButton
              onClick={() => {
                props.setOpenANCView(false);
                setSelectedWeek(null);
                setSelectedRow(null);
                setData(null);
              }}
            />
          </div>
        </div>
        <div className="sticky top-0 w-full">
          {/* <PatientInfo
            patientInfo={props.patientData}
            bloodgroupValue={props.bloodgroupValue}
          /> */}
        </div>

        <div className="w-full flex space-x-2 mt-2">
          <div className="w-[15%] shadow-md border border-gray-300 ">
            <div className="flex justify-between rounded-t-md">
              <p className="text-sm font-semibold text-customBlue pl-2 py-2 ">
                GA
              </p>
            </div>
            <hr className="h-[2px] bg-customBlue"></hr>
            <div className="h-[500px] overflow-y-auto">
              {vistitList.map((row) => (
                <div
                  key={row?.week}
                  className={` shadow-md rounded-md border p-2 m-1 border-gray-300 ${
                    selectedWeek === row?.visitDate
                      ? "bg-blue-900 text-white shadow-lg"
                      : "bg-white text-customBlue"
                  }`}
                  onClick={() => {
                    console.log("row7474", row);

                    handleSelect(row?.visitDate);
                    setSelectedRow(row);
                  }}
                >
                  <div className="my-1">{row?.week}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-[85%] shadow-md">
            <div className="  border border-[#8F873C] mb-2 rounded-md p-2 bg-[#fffce3]">
              <div>
                <div className="text-sm text-[#8F873C]  font-semibold w-full xl:text-[16px] lg:text-[12px] my-2">
                  Vitals
                </div>

                <div className="grid lg:grid-cols-4 grid-cols-2 md:grid-cols-3 gap-y-1 mx-4 mb-1">
                  {data?.vitals?.temperature !== null &&
                    data?.vitals?.temperature !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                          Temp
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.temperature} °F
                        </div>
                      </div>
                    )}
                  {data?.vitals?.pulseRate !== null &&
                    data?.vitals?.pulseRate !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                          PR
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.pulseRate} bpm
                        </div>
                      </div>
                    )}
                  {data?.vitals?.spO2 !== null && data?.vitals?.spO2 !== 0 && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                        spO2
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.vitals?.spO2} %
                      </div>
                    </div>
                  )}
                  {data?.vitals?.weight !== null &&
                    data?.vitals?.weight !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                          W
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.weight} kg
                        </div>
                      </div>
                    )}
                  {data?.vitals?.height !== null &&
                    data?.vitals?.height !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                          H
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.height} cm
                        </div>
                      </div>
                    )}
                  {data?.vitals?.bmi !== null && data?.vitals?.bmi !== 0 && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                        BMI
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.vitals?.bmi} kg/m2
                      </div>
                    </div>
                  )}
                  {data?.vitals?.respiration !== null &&
                    data?.vitals?.respiration !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                          Resp
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.respiration} bpm
                        </div>
                      </div>
                    )}
                  {data?.vitals?.bloodSugar !== null &&
                    data?.vitals?.bloodSugar !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                          BSL
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.vitals?.bloodSugar} mg/di
                        </div>
                      </div>
                    )}
                  {data?.vitals?.bsa !== null && data?.vitals?.bsa !== 0 && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                        BSA
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.vitals?.bsa} mg/di
                      </div>
                    </div>
                  )}
                  {(data?.vitals?.bloodPressureSystolic !== null &&
                    data?.vitals?.bloodPressureSystolic !== 0) ||
                    (data?.vitals?.bloodPressureDiastolic !== null &&
                      data?.vitals?.bloodPressureDiastolic !== 0 && (
                        <div className="flex space-x-1">
                          <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                            BP
                          </div>

                          <div className=" xl:text-sm lg:text-[12px]">
                            :&nbsp;&nbsp;
                            {data?.vitals?.bloodPressureSystolic}/
                            {data?.vitals?.bloodPressureDiastolic} mmHg
                          </div>
                        </div>
                      ))}
                </div>
              </div>
            </div>

            <div className="border border-[#8CC1F6] mb-2 rounded-md p-2 bg-[#ffffff]">
              {/* {vitalsFill?.some((val) => val !== null) || data?.vitals !== null ? ( */}
              <div>
                {/* {!areAllVitalsNull && ( */}
                <div className="text-sm text-[#8CC1F6]  font-semibold w-full xl:text-[16px] lg:text-[12px] my-2">
                  Examination
                </div>
                {/* )} */}

                {/* <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                              Vitals
                            </div> */}
                <div className="grid lg:grid-cols-2 grid-cols-2 md:grid-cols-1 gap-y-1 mx-4 mb-1">
                  {data?.examinations?.pr !== null && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                        PR
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.examinations?.pr}
                      </div>
                    </div>
                  )}
                  {data?.examinations?.pa !== null &&
                    data?.examinations?.pa !== 0 && (
                      <div className="flex space-x-1">
                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                          PA
                        </div>

                        <div className=" xl:text-sm lg:text-[12px]">
                          :&nbsp;&nbsp;{data?.examinations?.pa}
                        </div>
                      </div>
                    )}
                  {data?.examinations?.pv !== null && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                        PV
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.examinations?.pv}
                      </div>
                    </div>
                  )}
                  {data?.examinations?.speculum !== null && (
                    <div className="flex space-x-1">
                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                        Speculum
                      </div>

                      <div className=" xl:text-sm lg:text-[12px]">
                        :&nbsp;&nbsp;{data?.examinations?.speculum} kg
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* ) : null} */}
            </div>
            <div className="lg:my-2 xl:my-2 mb-2 border p-2 border-[#E449B1] bg-[#fcf3f9] rounded-md">
              <div className="text-sm text-[#E449B1] font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                Pathology
              </div>
              <div className="mb-1">
                {data?.pathology?.length > 0 &&
                  data?.pathology.map((row) => {
                    return (
                      <ul className="list-disc">
                        <li className="flex items-center text-sm ">
                          {" "}
                          • &nbsp;&nbsp;{row.investigation}{" "}
                        </li>
                      </ul>
                    );
                  })}
              </div>
            </div>
            <div className="lg:my-2 xl:my-2 mb-2 border p-2 border-[#8EFAB4] bg-[#EBFFF2] rounded-md">
              <div className="text-sm text-[#8EFAB4] font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                Sonography
              </div>
              <div className="mb-1">
                {data?.radiology?.length > 0 &&
                  data?.radiology.map((row) => {
                    return (
                      <ul className="list-disc">
                        <li className="flex items-center text-sm ">
                          {" "}
                          • &nbsp;&nbsp; {row.investigation}{" "}
                        </li>
                      </ul>
                    );
                  })}
              </div>
            </div>
            <div className="lg:my-2 xl:my-2 mb-2 border p-2 border-[#F8BC68] bg-[#FFF6EE] rounded-md">
              <div className="text-sm text-[#F8BC68] font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                Preventive Measures(Drug)
              </div>
              <div className="mb-1">
                {data?.prescriptions?.length > 0 &&
                  data?.prescriptions.map((row) => {
                    return (
                      <ul className="list-disc">
                        <li className="flex items-center text-sm ">
                          {" "}
                          • &nbsp;&nbsp; {row.drugName}{" "}
                        </li>
                      </ul>
                    );
                  })}
              </div>
            </div>
            <div className="lg:my-2 xl:my-2 mb-2 border p-2 border-[#BA88FF] bg-[#ECDFFF] rounded-md">
              <div className="text-sm text-[#BA88FF] font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                Counselling(Instruction)
              </div>
              <div className="mb-1">
                {data?.generalInstructions?.length > 0 &&
                  data?.generalInstructions.map((row) => {
                    return (
                      <ul className="list-disc">
                        <li className="flex items-center text-sm ">
                          {" "}
                          • &nbsp;&nbsp; {row}{" "}
                        </li>
                      </ul>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
